var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CRow',{attrs:{"alignVertical":"center"}},[_c('CCol',{attrs:{"md":"12","sm":"12"}},[_c('h5',{staticClass:"mt-3"},[_vm._v(" "+_vm._s(_vm.$t("Fields mapping"))+" ")]),_c('CCTableAddItems',{attrs:{"items":_vm.settings.fieldsMapping,"fields":[
                {
                    key: 'dataType',
                    label: 'Data type',
                },
                {
                    key: 'mappingName',
                    label: 'Mapping name',
                },
                {
                    key: '_toggled',
                    label: 'Toggled',
                    _active: false,
                    _defaultValue: false,
                },
                {
                    key: 'mappingValues',
                    label: 'Mapping values',
                    _active: false,
                    _defaultValue: {
                        values: [],
                        regexp: false,
                        defaultValue: null,
                    },
                }
            ],"showButtonToggleDetails":true,"normalizeItems":true},on:{"update:items":function($event){return _vm.$set(_vm.settings, "fieldsMapping", $event)}},scopedSlots:_vm._u([{key:"dataType",fn:function(ref){
            var item = ref.item;
return [_c('SelectAsync',{staticClass:"mb-0",attrs:{"value":item.dataType,"options":_vm.payload,"placeholder":_vm.$t('Select a field'),"invalidFeedback":_vm.$t('Field is requiered'),"size":"sm"},on:{"update:value":function($event){return _vm.$set(item, "dataType", $event)}}})]}},{key:"mappingName",fn:function(ref){
            var item = ref.item;
return [_c('CInput',{staticClass:"mb-0",attrs:{"value":item.mappingName,"placeholder":_vm.$t('Enter the value'),"invalidFeedback":_vm.$t('Value is required'),"size":"sm"},on:{"update:value":function($event){return _vm.$set(item, "mappingName", $event)}}})]}},{key:"details",fn:function(ref){
            var item = ref.item;
return [_c('CCollapse',{attrs:{"show":item._toggled}},[_c('CContainer',{attrs:{"fluid":true}},[_c('CRow',[_c('CCol',[_c('h5',[_vm._v(" "+_vm._s(_vm.$t("Mapping Values"))+" ")]),_c('p',{staticClass:"mb-0"},[_vm._v(" "+_vm._s(_vm.$t( "You can assign the value to sent." ))+". ")])])],1),_c('CRow',[_c('CCol',[_c('ButtonBulk',{attrs:{"value":item.mappingValues.values,"keyLeftValue":"inputValue","keyRightValue":"outputValue"},on:{"update:value":function($event){return _vm.$set(item.mappingValues, "values", $event)}}})],1)],1),_c('CRow',[_c('CCol',{attrs:{"col":"5"}},[_c('CCSwitch',{attrs:{"checked":item.mappingValues.regexp,"horizontal":_vm.defaultSwitchConfig.horizontal,"label":"Regexp mapping","color":"primary","shape":"pill","variant":"3d","size":"sm"},on:{"update:checked":function($event){return _vm.$set(item.mappingValues, "regexp", $event)}}})],1),_c('CCol',[_c('CInput',{staticClass:"mb-0",attrs:{"value":item.mappingValues.defaultValue,"horizontal":_vm.defaultInputConfig.horizontal,"label":"Default value","placeholder":_vm.$t(
                                            'Enter a default value'
                                        ),"size":"sm"},on:{"update:value":function($event){return _vm.$set(item.mappingValues, "defaultValue", $event)}}})],1)],1),_c('CRow',[_c('CCol',[_c('CCTableAddItems',{attrs:{"items":item.mappingValues.values,"fields":[
                                        {
                                            key: 'inputValue',
                                            label: 'Input value',
                                        },
                                        {
                                            key: 'outputValue',
                                            label: 'Output value',
                                        } ]},on:{"update:items":function($event){return _vm.$set(item.mappingValues, "values", $event)}},scopedSlots:_vm._u([{key:"inputValue",fn:function(ref){
                                    var index = ref.index;
return [_c('CInput',{staticClass:"mb-0",attrs:{"value":item.mappingValues.values[index].inputValue,"placeholder":_vm.$t('Enter the value'),"invalidFeedback":_vm.$t('Value is required'),"size":"sm"},on:{"update:value":function($event){return _vm.$set(item.mappingValues.values[index], "inputValue", $event)}}})]}},{key:"outputValue",fn:function(ref){
                                    var index = ref.index;
return [_c('CInput',{staticClass:"mb-0",attrs:{"value":item.mappingValues.values[index].outputValue,"placeholder":_vm.$t('Enter the value'),"invalidFeedback":_vm.$t('Value is required'),"size":"sm"},on:{"update:value":function($event){return _vm.$set(item.mappingValues.values[index], "outputValue", $event)}}})]}}],null,true)})],1)],1)],1)],1)]}}])})],1),_c('CCol',{attrs:{"md":"12","sm":"12"}},[_c('h5',{staticClass:"mt-3"},[_vm._v(" "+_vm._s(_vm.$t("Fixed fields"))+" ")]),_c('p',{staticClass:"mb-0"},[_vm._v(" "+_vm._s(_vm.$t("You can create fixed fields for your integration"))+". ")]),_c('CCTableAddItems',{attrs:{"items":_vm.settings.fixedFields,"fields":[
                {
                    key: 'name',
                    label: 'Field name',
                },
                {
                    key: 'value',
                    label: 'Field value',
                } ],"noItemsViewText":"Add parameter"},on:{"update:items":function($event){return _vm.$set(_vm.settings, "fixedFields", $event)}},scopedSlots:_vm._u([{key:"name",fn:function(ref){
            var item = ref.item;
return [_c('CInput',{staticClass:"mb-0",attrs:{"value":item.name,"placeholder":_vm.$t('Enter the name'),"invalidFeedback":_vm.$t('Name is required'),"size":"sm"},on:{"update:value":function($event){return _vm.$set(item, "name", $event)}}})]}},{key:"value",fn:function(ref){
            var item = ref.item;
return [_c('CInput',{staticClass:"mb-0",attrs:{"value":item.value,"placeholder":_vm.$t('Enter the value'),"invalidFeedback":_vm.$t('Value is required'),"size":"sm"},on:{"update:value":function($event){return _vm.$set(item, "value", $event)}}})]}}])})],1),_c('CCol',{attrs:{"md":"12","sm":"12"}},[_c('h5',{staticClass:"mt-3"},[_vm._v(" "+_vm._s(_vm.$t( "OK responses in body" ))+" ")]),_c('p',{staticClass:"mb-0"},[_vm._v(" "+_vm._s(_vm.$t( "Set the conditions to search in the body to mark the response as ok" ))+". ")]),_c('CCTableAddItems',{attrs:{"items":_vm.settings.matchResponseOKInBody,"fields":[
                {
                    key: 'condition',
                    label: 'condition',
                },
                {
                    key: 'value',
                    label: 'value',
                } ]},on:{"update:items":function($event){return _vm.$set(_vm.settings, "matchResponseOKInBody", $event)}},scopedSlots:_vm._u([{key:"condition",fn:function(ref){
                var item = ref.item;
return [_c('CSelect',{attrs:{"value":item.condition,"options":[
                        {
                            value: 'contains',
                            label: 'Contains',
                        },
                        {
                            value: 'not_contains',
                            label: 'Not contains',
                        } ],"placeholder":_vm.$t(
                            'Select a condition'
                        ),"size":"sm"},on:{"update:value":function($event){return _vm.$set(item, "condition", $event)}}})]}},{key:"value",fn:function(ref){
                var item = ref.item;
return [_c('CInput',{staticClass:"mb-0",attrs:{"value":item.value,"placeholder":_vm.$t(
                            'Enter the value'
                        ),"invalidFeedback":_vm.$t(
                            'Value is required'
                        ),"size":"sm"},on:{"update:value":function($event){return _vm.$set(item, "value", $event)}}})]}}])})],1),_c('CCol',{attrs:{"md":"12","sm":"12"}},[_c('h5',{staticClass:"mt-3"},[_vm._v(" "+_vm._s(_vm.$t("Match response DUP in body"))+" ")]),_c('p',{staticClass:"mb-0"},[_vm._v(" "+_vm._s(_vm.$t( "Set the conditions to search in the body to mark the response as duplicate" ))+". ")]),_c('CCTableAddItems',{attrs:{"items":_vm.settings.matchResponseDUPInBody,"fields":[
                {
                    key: 'condition',
                    label: 'condition',
                },
                {
                    key: 'value',
                    label: 'value',
                } ]},on:{"update:items":function($event){return _vm.$set(_vm.settings, "matchResponseDUPInBody", $event)}},scopedSlots:_vm._u([{key:"condition",fn:function(ref){
                var item = ref.item;
return [_c('CSelect',{attrs:{"value":item.condition,"options":[
                        {
                            value: 'contains',
                            label: 'Contains',
                        },
                        {
                            value: 'not_contains',
                            label: 'Not contains',
                        } ],"placeholder":_vm.$t(
                            'Select a condition'
                        ),"size":"sm"},on:{"update:value":function($event){return _vm.$set(item, "condition", $event)}}})]}},{key:"value",fn:function(ref){
                var item = ref.item;
return [_c('CInput',{staticClass:"mb-0",attrs:{"value":item.value,"placeholder":_vm.$t(
                            'Enter the value'
                        ),"invalidFeedback":_vm.$t(
                            'Value is required'
                        ),"size":"sm"},on:{"update:value":function($event){return _vm.$set(item, "value", $event)}}})]}}])})],1),_c('CCol',{attrs:{"md":"12","sm":"12"}},[_c('h5',{staticClass:"mt-3"},[_vm._v(" "+_vm._s(_vm.$t("Match response OK in headers"))+" ")]),_c('p',{staticClass:"mb-0"},[_vm._v(" "+_vm._s(_vm.$t( "Set the conditions to search in the headers to mark the response as ok" ))+". ")]),_c('CCTableAddItems',{attrs:{"items":_vm.settings.matchResponseOKInHeaders,"fields":[
                {
                    key: 'condition',
                    label: 'condition',
                },
                {
                    key: 'value',
                    label: 'value',
                } ]},on:{"update:items":function($event){return _vm.$set(_vm.settings, "matchResponseOKInHeaders", $event)}},scopedSlots:_vm._u([{key:"condition",fn:function(ref){
                var item = ref.item;
return [_c('CSelect',{attrs:{"value":item.condition,"options":[
                        {
                            value: 'contains',
                            label: 'Contains',
                        },
                        {
                            value: 'not_contains',
                            label: 'Not contains',
                        } ],"placeholder":_vm.$t(
                            'Select a condition'
                        ),"size":"sm"},on:{"update:value":function($event){return _vm.$set(item, "condition", $event)}}})]}},{key:"value",fn:function(ref){
                var item = ref.item;
return [_c('CInput',{staticClass:"mb-0",attrs:{"value":item.value,"placeholder":_vm.$t(
                            'Enter the value'
                        ),"invalidFeedback":_vm.$t(
                            'Value is required'
                        ),"size":"sm"},on:{"update:value":function($event){return _vm.$set(item, "value", $event)}}})]}}])})],1),_c('CCol',{attrs:{"md":"12","sm":"12"}},[_c('h5',{staticClass:"mt-3"},[_vm._v(" "+_vm._s(_vm.$t("Match response DUP in headers"))+" ")]),_c('p',{staticClass:"mb-0"},[_vm._v(" "+_vm._s(_vm.$t( "Set the conditions to search in the headers to mark the response as duplicate" ))+". ")]),_c('CCTableAddItems',{attrs:{"items":_vm.settings.matchResponseDUPInHeaders,"fields":[
                {
                    key: 'condition',
                    label: 'condition',
                },
                {
                    key: 'value',
                    label: 'value',
                } ]},on:{"update:items":function($event){return _vm.$set(_vm.settings, "matchResponseDUPInHeaders", $event)}},scopedSlots:_vm._u([{key:"condition",fn:function(ref){
                var item = ref.item;
return [_c('CSelect',{attrs:{"value":item.condition,"options":[
                        {
                            value: 'contains',
                            label: 'Contains',
                        },
                        {
                            value: 'not_contains',
                            label: 'Not contains',
                        } ],"placeholder":_vm.$t(
                            'Select a condition'
                        ),"size":"sm"},on:{"update:value":function($event){return _vm.$set(item, "condition", $event)}}})]}},{key:"value",fn:function(ref){
                var item = ref.item;
return [_c('CInput',{staticClass:"mb-0",attrs:{"value":item.value,"placeholder":_vm.$t(
                            'Enter the value'
                        ),"invalidFeedback":_vm.$t(
                            'Value is required'
                        ),"size":"sm"},on:{"update:value":function($event){return _vm.$set(item, "value", $event)}}})]}}])})],1),_c('CCol',{attrs:{"md":"12","sm":"12"}},[_c('h5',{staticClass:"mt-3"},[_vm._v(" "+_vm._s(_vm.$t("Match response OK in status line"))+" ")]),_c('p',{staticClass:"mb-0"},[_vm._v(" "+_vm._s(_vm.$t( "Set the conditions to search in the status line to mark the response as ok" ))+". ")]),_c('CCTableAddItems',{attrs:{"items":_vm.settings.matchResponseOKInStatusLine,"fields":[
                {
                    key: 'condition',
                    label: 'condition',
                },
                {
                    key: 'value',
                    label: 'value',
                } ]},on:{"update:items":function($event){return _vm.$set(_vm.settings, "matchResponseOKInStatusLine", $event)}},scopedSlots:_vm._u([{key:"condition",fn:function(ref){
                var item = ref.item;
return [_c('CSelect',{attrs:{"value":item.condition,"options":[
                        {
                            value: 'contains',
                            label: 'Contains',
                        },
                        {
                            value: 'not_contains',
                            label: 'Not contains',
                        } ],"placeholder":_vm.$t(
                            'Select a condition'
                        ),"size":"sm"},on:{"update:value":function($event){return _vm.$set(item, "condition", $event)}}})]}},{key:"value",fn:function(ref){
                var item = ref.item;
return [_c('CInput',{staticClass:"mb-0",attrs:{"value":item.value,"placeholder":_vm.$t(
                            'Enter the value'
                        ),"invalidFeedback":_vm.$t(
                            'Value is required'
                        ),"size":"sm"},on:{"update:value":function($event){return _vm.$set(item, "value", $event)}}})]}}])})],1),_c('CCol',{attrs:{"md":"12","sm":"12"}},[_c('h5',{staticClass:"mt-3"},[_vm._v(" "+_vm._s(_vm.$t("Match response DUP in status line"))+" ")]),_c('p',{staticClass:"mb-0"},[_vm._v(" "+_vm._s(_vm.$t( "Set the conditions to search in the status line to mark the response as duplicate" ))+". ")]),_c('CCTableAddItems',{attrs:{"items":_vm.settings.matchResponseDUPInStatusLine,"fields":[
                {
                    key: 'condition',
                    label: 'condition',
                },
                {
                    key: 'value',
                    label: 'value',
                } ]},on:{"update:items":function($event){return _vm.$set(_vm.settings, "matchResponseDUPInStatusLine", $event)}},scopedSlots:_vm._u([{key:"condition",fn:function(ref){
                var item = ref.item;
return [_c('CSelect',{attrs:{"value":item.condition,"options":[
                        {
                            value: 'contains',
                            label: 'Contains',
                        },
                        {
                            value: 'not_contains',
                            label: 'Not contains',
                        } ],"placeholder":_vm.$t(
                            'Select a condition'
                        ),"size":"sm"},on:{"update:value":function($event){return _vm.$set(item, "condition", $event)}}})]}},{key:"value",fn:function(ref){
                var item = ref.item;
return [_c('CInput',{staticClass:"mb-0",attrs:{"value":item.value,"placeholder":_vm.$t(
                            'Enter the value'
                        ),"invalidFeedback":_vm.$t(
                            'Value is required'
                        ),"size":"sm"},on:{"update:value":function($event){return _vm.$set(item, "value", $event)}}})]}}])})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }